import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet"; // Add this import
import Footer from "../HomePage/Footer";
import { useMediaQuery } from "react-responsive";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  Row,
  Col,
  Image,
  Button,
  Carousel,
  Flex,
  Anchor,
  Space,
  Spin,
} from "antd";
import ProductList from "../ProductList";
import { useParams } from "react-router-dom";
import Description from "./Tabs/Description";
import Highlights from "./Tabs/Highlights";
import Specifications from "./Tabs/Specifications";
import Accessories from "./Tabs/Accessories";
import Applications from "./Tabs/Applications";
import "./ProductPage.css";
import RotorTable from "./Tabs/RotorTable";
import {
  LeftOutlined,
  RightOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  PlayCircleOutlined
} from '@ant-design/icons';
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import { formatBreadcrumbText } from "../../../generalFunctions";
import { useReactToPrint } from "react-to-print";
import ProductCatalogPrint from "../../../components/config/product catalog/ProductCatalogPrint";
import { useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import QuotationBroucher from "../../../components/config/product catalog/QuotationBroucher";

function ProductPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [current, setCurrent] = useState(0);
  const [product, setProduct] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [showCatalog, setShowCatalog] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [anchorItems, setAnchorItems] = useState([
    {
      key: "description",
      title: "Description",
      href: "#description",
    },
    {
      key: "highlights",
      title: "Product Highlights",
      href: "#highlights",
    },
    {
      key: "specifications",
      title: "Performance Specifications",
      href: "#specifications",
    },
    {
      key: "applications",
      title: "Applications",
      href: "#applications",
    },
    {
      key: "accessories",
      title: "Optional Accessories",
      href: "#accessories",
    },
  ]);
  const [searchParams] = useSearchParams();
  const settings = {
    dots: { className: "custom-dots-product-details" },
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => {
      setCurrentSlide(current);
    },
  };
  const carouselRef = useRef(null);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const { main_category_url, category_url, subcategory_url, product_url } =
    useParams();

  const [productResponse, getProductRequest] = useApi(
    `/website/product-page/${product_url}`,
    null,
    API_METHODS.GET
  );

  const [relatedProductResponse, getRelatedProductRequest] = useApi(
    `/website/product-page/related-products/${product_url}`,
    null,
    API_METHODS.GET
  );

  const [productImage, setProductImage] = useState();
  const [imageResponse, getBase64Image] = useApi(
    `/website/product-page/get-image`,
    null,
    API_METHODS.POST
  );
  const [print, setPrint] = useState(false);
  const [showPrintCatlog, setShowPrintCatlog] = useState(false);

  const generateBreadcrumbSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: formatBreadcrumbText(main_category_url),
          item: `https://www.cenvance.com/${main_category_url}`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: formatBreadcrumbText(category_url),
          item: `https://www.cenvance.com/${main_category_url}/${category_url}`,
        },
        {
          "@type": "ListItem",
          position: 3,
          name: formatBreadcrumbText(subcategory_url),
          item: `https://www.cenvance.com/${main_category_url}/${category_url}/${subcategory_url}`,
        },
        {
          "@type": "ListItem",
          position: 4,
          name: product?.product_name,
          item: window.location.href,
        },
      ],
    };
  };

  useEffect(() => {
    if (imageResponse.data && !imageResponse.isLoading) {
      const data =
        imageResponse.data !== BLANK_VALUE
          ? imageResponse.data?.image
          : [];

      if (print) {
        setProductImage(data, setShowPrintCatlog(true));
        setPrint(false)
        return;
      }
      else {
        setProductImage(data, setShowCatalog(true));
      }
    }
  }, [imageResponse]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: product ? `${product.product_name} Catalog` : "Catalog",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  // const { toPDF, targetRef } = usePDF({
  //   method: "save",
  //   filename: product ? `${product.product_name} Catalog` : "Catalog",
  //   page: { margin: Margin.SMALL, orientation: "landscape" },
  // });

  const printCatalog = () => {
    // setShowCatalog(!showCatalog, handlePrint());
    // handlePrint();
    getBase64Image({ url: product?.product_images[0].image_path });
    setPrint(true);
  }

  const downloadCatlog = () => {
    getBase64Image({ url: product?.product_images[0].image_path });
    setDownloading(true);
  }

  const downloadPDF = async () => {
    try {
      let pdf = null;
      const pages = document.querySelectorAll('.page-content');

      if (pages.length === 0) {
        alert('No content found to generate PDF');
        return;
      }

      const pdfWidth = 297; // A4 landscape width in mm
      const pdfHeight = 210; // A4 landscape height in mm

      for (let i = 0; i < pages.length; i++) {
        await new Promise(resolve => setTimeout(resolve, 300));

        // Get the actual rendered height of the element
        const elementHeight = pages[i].scrollHeight;
        const elementWidth = pages[i].scrollWidth;


        const canvas = await html2canvas(pages[i], {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: false,
          backgroundColor: '#ffffff',
          width: elementWidth,
          height: elementHeight,
          windowWidth: elementWidth,
          windowHeight: elementHeight
        });

        if (!canvas || canvas.width === 0 || canvas.height === 0) {
          console.error(`Invalid canvas for page ${i + 1}`);
          continue;
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.98);

        // Calculate dimensions to fit PDF page width
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        // Validate dimensions
        if (!isFinite(imgWidth) || !isFinite(imgHeight) || imgWidth <= 0 || imgHeight <= 0) {
          console.error(`Invalid dimensions for page ${i + 1}`);
          continue;
        }

        // If content is taller than one page, split it properly
        if (imgHeight > pdfHeight) {
          const totalPages = Math.ceil(imgHeight / pdfHeight);

          for (let pageNum = 0; pageNum < totalPages; pageNum++) {
            // Initialize PDF or add new page
            if (pdf === null && pageNum === 0) {
              pdf = new jsPDF('l', 'mm', 'a4');
            } else {
              pdf.addPage();
            }

            // Calculate the portion of the image for this page
            const sourceY = (pageNum * pdfHeight * canvas.width) / pdfWidth;
            const sourceHeight = Math.min(
              (pdfHeight * canvas.width) / pdfWidth,
              canvas.height - sourceY
            );

            // Create a temporary canvas for this slice
            const sliceCanvas = document.createElement('canvas');
            sliceCanvas.width = canvas.width;
            sliceCanvas.height = sourceHeight;

            const ctx = sliceCanvas.getContext('2d');
            ctx.drawImage(
              canvas,
              0, sourceY,                    // source x, y
              canvas.width, sourceHeight,     // source width, height
              0, 0,                           // destination x, y
              canvas.width, sourceHeight      // destination width, height
            );

            const sliceImgData = sliceCanvas.toDataURL('image/jpeg', 0.98);
            const sliceHeight = (sourceHeight * pdfWidth) / canvas.width;

            pdf.addImage(
              sliceImgData,
              'JPEG',
              0,
              0,
              imgWidth,
              sliceHeight
            );
          }
        } else {
          // Content fits in one page
          if (pdf === null) {
            pdf = new jsPDF('l', 'mm', 'a4');
          } else {
            pdf.addPage();
          }

          pdf.addImage(
            imgData,
            'JPEG',
            0,
            0,
            imgWidth,
            imgHeight
          );
        }
      }

      if (pdf) {
        pdf.save(product ? `${product.product_name} Catalog.pdf` : "Catalog.pdf");
        setShowCatalog(false);
        setDownloading(false);
      } else {
        alert('No valid pages to generate PDF');
        setDownloading(false);
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
    }
  };

  useEffect(() => {
    getProductRequest(
      "",
      API_METHODS.GET,
      `/website/product-page/${product_url}`
    );
    getRelatedProductRequest(
      "",
      API_METHODS.GET,
      `/website/product-page/related-products/${product_url}`
    );
  }, [product_url]);

  useEffect(() => {
    const data =
      productResponse.data !== BLANK_VALUE ? productResponse.data : [];
    setProduct(data);

    // Update anchor items based on product data
    if (data?.rotors && data.rotors.length > 0) {
      setAnchorItems((prevItems) => {
        // Check if rotors item already exists to avoid duplicates
        const rotorsExists = prevItems.some((item) => item.key === "rotors");
        if (!rotorsExists) {
          return [
            ...prevItems,
            {
              key: "rotors",
              title: "Additional Rotors",
              href: "#rotors",
            },
          ];
        }
        return prevItems;
      });
    } else {
      // Remove rotors item if no rotor data
      setAnchorItems((prevItems) =>
        prevItems.filter((item) => item.key !== "rotors")
      );
    }
  }, [productResponse]);

  useEffect(() => {
    const data =
      relatedProductResponse.data !== BLANK_VALUE
        ? relatedProductResponse.data
        : [];
    setRelatedProducts(data);
  }, [relatedProductResponse]);

  useEffect(() => {
    if (showCatalog) {
      downloadPDF()
    }
  }, [showCatalog]);

  useEffect(() => {
    if (showPrintCatlog) {
      handlePrint()
      setShowPrintCatlog(false);
    }
  }, [showPrintCatlog]);

  return (
    <Spin spinning={!product} size="large">
      {/* SEO HEAD SECTION - COMPLETELY INVISIBLE */}
      {product && (
        <Helmet>
          {/* Primary Meta Tags */}
          <title>
            {product.meta_title || `${product.product_name} - Cenvance`}
          </title>
          <meta
            name="description"
            content={product.meta_description || product.description}
          />
          {product.meta_keywords && (
            <meta name="keywords" content={product.meta_keywords} />
          )}
          <meta
            name="robots"
            content={product.meta_robots || "index, follow"}
          />

          {/* Canonical URL */}
          <link
            rel="canonical"
            href={product.canonical_url || window.location.href}
          />

          {/* Open Graph Tags */}
          <meta
            property="og:title"
            content={product.og_title || product.product_name}
          />
          <meta
            property="og:description"
            content={product.og_description || product.description}
          />
          <meta
            property="og:image"
            content={
              product.og_image || product.product_images?.[0]?.image_path
            }
          />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="product" />
          <meta property="og:site_name" content="Cenvance" />

          {/* Twitter Card Tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={product.twitter_title || product.product_name}
          />
          <meta
            name="twitter:description"
            content={product.twitter_description || product.description}
          />
          <meta
            name="twitter:image"
            content={
              product.twitter_image ||
              product.og_image ||
              product.product_images?.[0]?.image_path
            }
          />

          {/* Breadcrumb Structured Data */}
          <script type="application/ld+json">
            {JSON.stringify(generateBreadcrumbSchema())}
          </script>

          {/* Additional Schema if exists */}
          {product.additional_schema && (
            <script type="application/ld+json">
              {typeof product.additional_schema === "string"
                ? product.additional_schema
                : JSON.stringify(product.additional_schema)}
            </script>
          )}
        </Helmet>
      )}

      <Breadcrumbs
        items={[
          {
            title: formatBreadcrumbText(main_category_url),
            href: `/${main_category_url}/${category_url}`,
          },
          {
            title: formatBreadcrumbText(category_url),
            href: `/${main_category_url}/${category_url}`,
          },
          {
            title: formatBreadcrumbText(subcategory_url),
            href: `/${main_category_url}/${category_url}/${subcategory_url}`,
          },
          {
            title: formatBreadcrumbText(product_url),
          },
        ]}
      />
      <div
        style={{
          marginBottom: "24px",
          padding: !isTabletOrMobile ? "60px 170px" : 12,
        }}
      >
        <h2 className="product-name">{product?.product_name}</h2>
        <Row gutter={[24, 24]} align="top" justify="center">
          <Col xs={24} md={18}>
            <Image.PreviewGroup
              preview={{
                toolbarRender: (
                  _,
                  {
                    transform: { scale },
                    actions: {
                      onActive,
                      onRotateLeft,
                      onRotateRight,
                      onZoomOut,
                      onZoomIn,
                      onReset,
                    },
                  }
                ) => (
                  <Space size={12} className="toolbar-wrapper">
                    <LeftOutlined
                      onClick={() =>
                        onActive === null || onActive === void 0
                          ? void 0
                          : onActive(-1)
                      }
                    />
                    <RightOutlined
                      onClick={() =>
                        onActive === null || onActive === void 0
                          ? void 0
                          : onActive(1)
                      }
                    />
                    <RotateLeftOutlined onClick={onRotateLeft} />
                    <RotateRightOutlined onClick={onRotateRight} />
                    <ZoomOutOutlined
                      disabled={scale === 1}
                      onClick={onZoomOut}
                    />
                    <ZoomInOutlined
                      disabled={scale === 50}
                      onClick={onZoomIn}
                    />
                  </Space>
                ),
                onChange: (index) => {
                  setCurrent(index);
                },
              }}
            >
              {product?.product_images && product.product_images.length > 0 ? (
                <Carousel ref={carouselRef} {...settings}>
                  {/* Product Images */}
                  {product?.product_images?.map((img, index) => (
                    <div key={index}>
                      <Image
                        src={img.image_path}
                        alt={`${product.product_name} - Image ${index + 1}`}
                        style={{
                          width: "100%",
                          height: 600,
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  ))}

                  {/* Video Slide with iframe */}
                  {product?.video && (
                    <div key="video-slide">
                      <div
                        style={{
                          width: "100%",
                          height: 600,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            paddingBottom: "56.25%" /* 16:9 aspect ratio */,
                            height: 0,
                            maxHeight: 600,
                          }}
                        >
                          <iframe
                            src={product.video}
                            title={`${product.product_name} Video`}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              border: "none",
                            }}
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </Carousel>
              ) : (
                <Image
                  src="./placeholder-image.png"
                  alt="No images available"
                  style={{ width: "100%" }}
                />
              )}
            </Image.PreviewGroup>
          </Col>
        </Row>
        {product?.product_images && product.product_images.length > 0 && (
          <Row
            gutter={[8, 8]}
            justify="center"
            style={{ marginTop: 16, paddingBottom: 20 }}
          >
            {/* Image Thumbnails */}
            {product.product_images.map((thumb, index) => (
              <Col key={index}>
                <Image
                  src={thumb.image_path}
                  preview={false}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "cover",
                    cursor: "pointer",
                    border:
                      currentSlide === index
                        ? "3px solid #1890ff"
                        : "1px solid #d9d9d9",
                    borderRadius: 4,
                  }}
                  onClick={() => {
                    setCurrentSlide(index);
                    carouselRef.current?.goTo(index);
                  }}
                />
              </Col>
            ))}

            {/* Video Thumbnail - using first product image */}
            {product?.video && product?.product_images?.[0] && (
              <Col key="video-thumb">
                <div
                  style={{
                    width: 80,
                    height: 80,
                    cursor: "pointer",
                    border:
                      currentSlide === product.product_images.length
                        ? "3px solid #1890ff"
                        : "1px solid #d9d9d9",
                    borderRadius: 4,
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    const videoIndex = product.product_images.length;
                    setCurrentSlide(videoIndex);
                    carouselRef.current?.goTo(videoIndex);
                  }}
                >
                  {/* Use first product image as thumbnail */}
                  <img
                    src={product.product_images[0].image_path}
                    alt="Video thumbnail"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />

                  {/* Dark overlay for better play icon visibility */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.3)",
                    }}
                  />

                  {/* Play Icon Overlay */}
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 2,
                    }}
                  >
                    <PlayCircleOutlined
                      style={{
                        fontSize: 32,
                        color: "white",
                        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.8))",
                      }}
                    />
                  </div>
                </div>
              </Col>
            )}
          </Row>
        )}
        <Flex justify="center" gap={18}>
          <Button type="primary" className="custom-button">
            Enquire Now
          </Button>
          {searchParams.get("print") == "true" && (
            <Button
              className="custom-button"
              loading={print}
              style={{ color: "black" }}
              onClick={() => printCatalog()}
            >
              Print Catalogue
            </Button>
          )}
          <Button
            className="custom-button"
            style={{ color: "black" }}
            loading={downloading}
            onClick={() => downloadCatlog()}
          >
            Download Catalogue
          </Button>
        </Flex>

        <Space
          direction="vertical"
          style={{ width: "100%", marginTop: "60px", display: "block" }}
        >
          <Anchor
            direction="horizontal"
            affix={true}
            items={anchorItems}
            style={{
              paddingBottom: 20,
              backgroundColor: "white",
              borderBottom: "1px solid #f0f0f0",
              zIndex: 100,
              width: "100%",
            }}
            offsetTop={0}
            targetOffset={80}
            className="full-width-anchor"
          />
          <div id="description">
            <Description product={product} />
          </div>
          <div id="highlights">
            <Highlights product={product} />
          </div>
          <div id="specifications">
            <Specifications product={product} />
          </div>
          <div id="applications">
            <Applications product={product} />
          </div>
          <div id="accessories">
            <Accessories product={product} />
          </div>

          {product?.rotors?.length > 0 && (
            <div id="rotors">
              <RotorTable rotorData={product.rotors} />
            </div>
          )}
        </Space>
      </div>

      {relatedProducts && (
        <div style={{ padding: "50px 120px 120px 120px" }}>
          <ProductList
            products={relatedProducts}
            isTabletOrMobile={isTabletOrMobile}
          />
        </div>
      )}
      <div style={{ marginTop: 60 }}>
        <Footer isTabletOrMobile={isTabletOrMobile} />
      </div>

      {product && (
        <div style={{ visibility: "hidden", display: "none" }}>
          <ProductCatalogPrint
            componentRef={componentRef}
            catalogDetails={product}
            image={productImage}
          />
        </div>
      )}

      {product && showCatalog && (
        <QuotationBroucher catalogDetails={product} image={productImage} />
      )}
    </Spin>
  );
}

export default ProductPage;
